var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icon-lady-desk_160x160");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0.096 0.064 160 0.064 160 160 0.096 160"
}), /*#__PURE__*/React.createElement("path", {
  d: "M160,80 C160,124.1824 124.1824,160 80,160 C37.1522654,160 2.17159485,126.313677 0.0972969322,83.9803401 L0.0972969322,76.0196599 C2.12039142,34.7313086 35.4453415,1.66834259 76.841707,0.061202094 L83.158293,0.061202094",
  id: "path-3"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Illustration-Audit-Overall",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Illustration-Audit-5",
  transform: "translate(-180.000000, -451.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3-Copy-37",
  transform: "translate(167.000000, 451.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(13.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "100x100_Learn-new-info_scaled-illustration_grey-RGB"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M160,80 C160,124.1824 124.1824,160 80,160 C35.8176,160 0,124.1824 0,80 C0,35.8176 35.8176,0 80,0 C124.1824,0 160,35.8176 160,80",
  id: "Fill-1",
  fill: "#D6D5CD",
  mask: "url(#mask-2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M160,80 C160,124.1824 124.1824,160 80,160 C35.8176,160 0,124.1824 0,80 C0,35.8176 35.8176,0 80,0 C124.1824,0 160,35.8176 160,80",
  id: "Fill-3",
  fill: "#EEF2F6",
  mask: "url(#mask-2)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-54"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-4",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-3"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M95.3264,34.72 C96.0528,40.112 92.1264,45.0912 86.56,45.84 C80.992,46.5888 75.8896,42.8256 75.1648,37.4336 C74.4384,32.04 78.3648,27.0624 83.9312,26.312 C89.4992,25.5632 94.6016,29.328 95.3264,34.72",
  id: "Fill-5",
  fill: "#AE502D",
  mask: "url(#mask-4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.9136,40.4784 C98.6256,45.7584 93.9088,50.752 87.384,51.6304 C80.8576,52.5088 74.992,48.9392 74.28,43.6576 C73.5696,38.376 78.2848,33.384 84.8112,32.5056 C91.336,31.6272 97.2032,35.1968 97.9136,40.4784",
  id: "Fill-7",
  fill: "#FFFFFE",
  mask: "url(#mask-4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M106.8368,51.1984 C108.2992,62.072 100.7936,72.0576 90.072,73.5008 C79.3488,74.944 69.4688,67.2976 68.0064,56.4224 C66.5424,45.5472 74.0496,35.5616 84.7712,34.1184 C95.496,32.6768 105.3728,40.3232 106.8368,51.1984",
  id: "Fill-8",
  fill: "#AE502D",
  mask: "url(#mask-4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M89.6704,78.2592 C72.5264,78.2592 66.072,84.2608 66.072,84.2608 L75.2144,134.6592 L104.128,134.6592 L113.2704,84.2608 C113.2704,84.2608 106.816,78.2592 89.6704,78.2592",
  id: "Fill-9",
  fill: "#D14F2B",
  mask: "url(#mask-4)"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Fill-10",
  fill: "#CFA486",
  mask: "url(#mask-4)",
  points: "82.8752 78 82.4944 61.496 96.3392 61.1744 96.7216 77.656 82.8752 78"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Fill-11",
  fill: "#924429",
  mask: "url(#mask-4)",
  points: "96.5648 70.8608 96.3392 61.1744 82.592 61.4928 82.4944 55.0112 96.5648 53.2752 96.5648 70.8608"
}), /*#__PURE__*/React.createElement("path", {
  d: "M88.0528,74.128 C86.2288,74.128 84.4544,73.8656 82.7696,73.3792 L82.592,61.4928 L96.3392,61.1744 L96.5648,70.8608 L96.5648,72.1312 C94.496,73.1584 92.2064,73.8336 89.7648,74.0512 C89.1904,74.1024 88.6192,74.128 88.0528,74.128",
  id: "Fill-12",
  fill: "#AE8A70",
  mask: "url(#mask-4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.6272,56.3088 C67.2336,45.9536 74.5456,36.424 84.9568,35.024 C95.368,33.6224 104.9376,40.88 106.3312,51.2352 C107.7248,61.5888 100.4144,71.12 90.0016,72.52 C79.592,73.9216 70.0208,66.664 68.6272,56.3088",
  id: "Fill-13",
  fill: "#CFA486",
  mask: "url(#mask-4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M94.6416,56.7856 C94.7168,57.3408 94.3232,57.8544 93.7632,57.9296 C93.2016,58.0048 92.6896,57.6144 92.6144,57.0576 C92.5392,56.5024 92.9312,55.9888 93.4912,55.9136 C94.0512,55.8384 94.5664,56.2288 94.6416,56.7856",
  id: "Fill-14",
  fill: "#3B3C3A",
  mask: "url(#mask-4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.7936,58.7856 C80.8688,59.3424 81.384,59.7328 81.944,59.6576 C82.5024,59.5824 82.896,59.0688 82.8208,58.5136 C82.7456,57.9584 82.232,57.5664 81.672,57.6416 C81.112,57.7168 80.72,58.2304 80.7936,58.7856",
  id: "Fill-15",
  fill: "#3B3C3A",
  mask: "url(#mask-4)"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Fill-16",
  fill: "#CFA486",
  mask: "url(#mask-4)",
  points: "106.7904 102.3056 117.6944 120.0288 127.1024 119.4896 121.6144 103.8256 106.7904 102.3056"
}), /*#__PURE__*/React.createElement("path", {
  d: "M89.9968,126.8528 L90.2832,122.5312 L69.4928,116.592 L61.8496,116.424 C61.3184,116.4128 60.9344,116.2384 60.848,116.7632 C59.6208,124.2608 63.896,125.8752 64.7232,126.1664 L89.9968,126.8528",
  id: "Fill-17",
  fill: "#CFA486",
  mask: "url(#mask-4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M101.088,125.2816 C101.088,125.2816 99.6128,126.4368 96.2752,127.072 C92.9376,127.7072 89.288,126.7184 89.288,126.7184 L84.8272,123.4448 L89.5712,122.3968 L99.5808,122.1008 C99.952,122.0896 100.3184,122.1744 100.6448,122.3472 L105.6016,124.9696 C105.9648,125.1632 106.032,125.5968 105.9184,126.024 C105.7776,126.5616 105.1872,126.8448 104.6816,126.6192 L101.088,125.2816",
  id: "Fill-18",
  fill: "#CFA486",
  mask: "url(#mask-4)"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Fill-19",
  fill: "#D14F2B",
  mask: "url(#mask-4)",
  points: "114.0832 114.8832 124.8688 113.1136 116.9312 90.0576 102.5312 95.888 114.0832 114.8832"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Fill-20",
  fill: "#CFA486",
  mask: "url(#mask-4)",
  points: "73.8768 101.3216 69.5776 121.4976 60.6928 119.2832 62.0864 99.6176 73.8768 101.3216"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Fill-21",
  fill: "#D14F2B",
  mask: "url(#mask-4)",
  points: "72.5408 114.4288 61.0592 114.1184 62.6672 90.2096 76.7696 94.1824 72.5408 114.4288"
}), /*#__PURE__*/React.createElement("path", {
  d: "M117,91.1568 C117,95.8352 113.2064,99.6304 108.5248,99.6304 C103.8448,99.6304 100.0512,95.8352 100.0512,91.1568 C100.0512,86.4752 103.8448,82.6816 108.5248,82.6816 C113.2064,82.6816 117,86.4752 117,91.1568",
  id: "Fill-22",
  fill: "#D14F2B",
  mask: "url(#mask-4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79.6304,91.1216 C79.6304,95.8016 75.8368,99.5968 71.1552,99.5968 C66.4752,99.5968 62.6816,95.8016 62.6816,91.1216 C62.6816,86.4416 66.4752,82.648 71.1552,82.648 C75.8368,82.648 79.6304,86.4416 79.6304,91.1216",
  id: "Fill-23",
  fill: "#D14F2B",
  mask: "url(#mask-4)"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-24",
  fill: "#D14F2B",
  mask: "url(#mask-4)",
  points: "80.9152 79.0208 98.5088 79.0208 98.5088 74.528 80.9152 74.528"
}), /*#__PURE__*/React.createElement("path", {
  d: "M76.832,45.0144 C76.832,45.0144 77.424,54.1776 95.5616,51.5552 C95.5616,51.5552 102.1632,51.352 100.8848,56.5136 C99.8608,60.6448 98.4672,62.8544 101.9536,65.2256 C104.1456,66.7152 100.4128,71.12 100.4128,71.12 C100.4128,71.12 107.7456,67.488 105.9472,63.4288 C105.1392,61.6032 105.9088,59.7984 106.2672,58.8272 C107.6064,55.2032 108.5552,45.4128 95.1392,40.2624 C81.7232,35.1104 77.1968,39.5648 76.832,45.0144",
  id: "Fill-25",
  fill: "#AE502D",
  mask: "url(#mask-4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M76.4496,37.9264 C76.4496,37.9264 84.6416,30.952 96.1696,36.3632 C96.1696,36.3632 112.9568,44.4544 104.7312,63.592 L103.2592,63.152 L101.6368,54.1232 L100.2496,49.0016 L93.5392,46.8848 L81.1824,43.3296 L76.832,45.0144 L76.4496,37.9264",
  id: "Fill-26",
  fill: "#AE502D",
  mask: "url(#mask-4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M75.112,69.0096 C74.3696,67.1872 73.7728,65.2752 73.3712,63.3488 C73.0432,61.7808 72.6944,59.8752 73.2976,58.3296 C73.4352,57.9744 73.6336,57.6432 73.9216,57.3904 C76.5392,55.0848 79.672,52.8688 77.5872,46.376 C75.5008,39.8848 82.7088,36.992 82.7088,36.992 C82.1472,36.9216 81.584,36.8528 81.0208,36.7824 C79.7952,36.6304 78.7696,36.3584 77.6752,37.088 C76.7504,37.704 75.824,38.3072 74.9472,38.9936 C73.1344,40.416 71.5136,42.0928 70.312,44.0672 C68.8272,46.5056 67.9776,49.2832 67.8112,52.1312 C67.72,53.6896 67.808,55.256 68.0672,56.7936 C68.4032,58.7776 69.2944,61.4704 70.2752,63.2064 C71.632,65.6048 73.256,66.9712 75.112,69.0096",
  id: "Fill-27",
  fill: "#AE502D",
  mask: "url(#mask-4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M107.488,103.16 L105.0896,99.7584 L103.992,98.4832 C103.7392,98.1904 103.2944,98.1488 103.0032,98.4032 C102.8608,98.5264 102.7216,98.7136 102.6064,98.9936 C102.1968,99.9792 103.6272,101.3184 103.7632,101.4832 C103.8992,101.6464 104.7696,102.8288 104.7696,102.8288 L105.904,105.5344 C105.9392,105.6624 108.2192,106.5792 108.225623,105.3376 C108.2304,104.0976 107.488,103.16 107.488,103.16",
  id: "Fill-28",
  fill: "#CFA486",
  mask: "url(#mask-4)"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-30",
  fill: "#FFFFFE",
  mask: "url(#mask-4)",
  points: "85.2032 116.9296 106.2032 116.9296 106.2032 86.9296 85.2032 86.9296"
}), /*#__PURE__*/React.createElement("path", {
  d: "M102.1168,123.1712 L103.1872,125.3712 C103.3568,125.5376 103.5536,125.6704 103.7728,125.7568 C104.2448,125.9424 106.936,126.4944 107.5952,126.6272 C107.8336,126.6752 108.072,126.5408 108.1552,126.3104 C108.2928,125.9296 108.1008,125.5088 107.7248,125.3632 L102.1168,123.1712",
  id: "Fill-32",
  fill: "#CFA486",
  mask: "url(#mask-4)"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Fill-33",
  fill: "#CFA486",
  mask: "url(#mask-4)",
  points: "105.2848 126.1376 99.7776 125.6656 97.76 123.784 105.2848 126.1376"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.0848,55.0112 C78.0848,55.0112 79.4272,53.1328 81.9472,53.2272 M95.7552,53.7408 C95.7552,53.7408 93.7248,52.6384 91.4992,53.8272",
  id: "Stroke-34",
  stroke: "#AE502D",
  strokeWidth: 1.0672,
  strokeLinecap: "round",
  mask: "url(#mask-4)"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-40",
  fill: "#FFFFFE",
  mask: "url(#mask-4)",
  points: "20.632 118.2384 68.9136 118.2384 68.9136 108.88 20.632 108.88"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-41",
  fill: "#2A2D70",
  mask: "url(#mask-4)",
  points: "16.4448 108.8336 64.7264 108.8336 64.7264 101.2864 16.4448 101.2864"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-42",
  fill: "#D14F2B",
  mask: "url(#mask-4)",
  points: "16.4448 125.7856 64.7264 125.7856 64.7264 118.2384 16.4448 118.2384"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-43",
  fill: "#E7792B",
  mask: "url(#mask-4)",
  points: "16.4448 125.7856 42.8784 125.7856 42.8784 118.2384 16.4448 118.2384"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-44",
  fill: "#FFFFFE",
  mask: "url(#mask-4)",
  points: "16.4448 101.2848 64.7264 101.2848 64.7264 96.7504 16.4448 96.7504"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-45",
  fill: "#5D6060",
  mask: "url(#mask-4)",
  points: "48.7808 101.2848 64.7264 101.2848 64.7264 96.7504 48.7808 96.7504"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-46",
  fill: "#6F7271",
  mask: "url(#mask-4)",
  points: "7.9936 160 157.9184 160 157.9184 125.8192 7.9936 125.8192"
}), /*#__PURE__*/React.createElement("line", {
  x1: 33.9952,
  y1: 79.6752,
  x2: 33.9952,
  y2: 64.0368,
  id: "Stroke-47",
  stroke: "#2A2D70",
  strokeWidth: 1.0672,
  mask: "url(#mask-4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.3488,58.9232 C40.4656,56.432 42.7104,59.0272 42.7104,59.0272 C42.7104,59.0272 44.7504,61.7888 41.6352,64.2816 C38.5184,66.7744 33.696,66.2384 33.696,66.2384 C33.696,66.2384 34.232,61.416 37.3488,58.9232",
  id: "Fill-48",
  fill: "#2A2D70",
  mask: "url(#mask-4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.4496,59.3296 C25.4496,59.3296 27.6032,56.656 30.8048,59.0384 C32.8544,60.5632 33.88,63.0768 34.3536,64.6912 C34.6208,65.5984 34.7104,66.2208 34.7104,66.2208 C34.7104,66.2208 29.9104,66.9248 26.7088,64.5424 C23.5072,62.1584 25.4496,59.3296 25.4496,59.3296",
  id: "Fill-49",
  fill: "#2A2D70",
  mask: "url(#mask-4)"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Fill-50",
  fill: "#E3772B",
  mask: "url(#mask-4)",
  points: "41.3376 96.7936 26.6512 96.7936 24.6592 80.4048 43.3328 80.4048 41.3376 96.7936"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Fill-51",
  fill: "#DD5D2B",
  mask: "url(#mask-4)",
  points: "24.8256 81.7792 25.1344 84.3168 42.856 84.3168 43.1648 81.7792 24.8256 81.7792"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.304,80.9872 C23.304,81.424 23.6576,81.7776 24.096,81.7776 L43.8944,81.7776 C44.3328,81.7776 44.6864,81.424 44.6864,80.9872 L44.6864,78.3632 C44.6864,77.9264 44.3328,77.5712 43.8944,77.5712 L24.096,77.5712 C23.6576,77.5712 23.304,77.9264 23.304,78.3632 L23.304,80.9872",
  id: "Fill-52",
  fill: "#E3772B",
  mask: "url(#mask-4)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M103.3888,109.248 C101.2272,108.3408 99.9856,106.216 100.616,104.504 C101.2464,102.792 103.5104,102.1392 105.672,103.0464 C107.8336,103.9536 109.0752,106.0784 108.4432,107.792 C107.8144,109.504 105.5504,110.1568 103.3888,109.248",
  id: "Fill-55",
  fill: "#CFA486"
}), /*#__PURE__*/React.createElement("path", {
  d: "M99.944,108.8704 L99.6496,109.0432 L96.264,107.992 C96.3568,107.824 96.4816,107.6832 96.6272,107.5776 L99.7824,108.5568 L99.944,108.8704",
  id: "Fill-56",
  fill: "#9C796A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M99.496,106.1184 L99.5472,106.3584 L99.2528,106.5296 L93.992,104.8992 C94.1136,104.7456 94.2688,104.6256 94.4384,104.5488 L94.4944,104.5264 L99.3872,106.0448 L99.496,106.1184",
  id: "Fill-57",
  fill: "#9C796A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M94.32,101.888 L94.44,101.9248 L100.0416,103.6624 L100.2032,103.976 L100.1728,104.0416 L99.9088,104.1488 L93.4432,102.1424 C93.688,101.9408 94.0016,101.8432 94.32,101.888",
  id: "Fill-58",
  fill: "#9C796A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M100.2032,103.976 L100.0416,103.6624 L94.44,101.9248 L94.4336,101.9088 C94.2704,101.6176 94.2176,101.2576 94.3136,100.904 C94.4992,100.2336 95.1584,99.8464 95.784,100.04 L106.072,103.2336 C106.6992,103.4272 107.0576,104.1296 106.872,104.8016 C106.7744,105.152 106.5504,105.4256 106.2656,105.5776 L109.7968,106.6736 C110.424,106.8688 110.7808,107.5696 110.5968,108.2416 C110.4832,108.656 110.1888,108.9616 109.8336,109.0896 C109.6128,109.1696 109.3664,109.1808 109.1264,109.1056 L108.5328,108.9216 C108.544,109.0688 108.5312,109.2192 108.4912,109.3696 C108.304,110.04 108.0416,109.6896 107.416,109.496 L106.2064,110.1248 C105.4544,111.3824 103.9952,112.0224 102.592,111.5872 L102.4832,111.5456 L102.376,111.5264 L96.9504,109.8416 C96.3232,109.648 95.9664,108.9456 96.1504,108.2736 L96.264,107.992 L99.6496,109.0432 L99.944,108.8704 L99.7824,108.5568 L96.6272,107.5776 L96.6288,107.576 L94.5568,106.9328 C93.9296,106.7392 93.5696,106.0368 93.7568,105.3648 C93.8048,105.1872 93.8864,105.0304 93.992,104.8992 L99.2528,106.5296 L99.5472,106.3584 L99.496,106.1184 L99.3872,106.0448 L94.4944,104.5264 L94.4384,104.5488 L93.8304,104.36 L93.5632,104.2368 C93.1056,103.952 92.872,103.36 93.0288,102.792 C93.1024,102.5232 93.2512,102.3008 93.4432,102.1424 L99.9088,104.1488 L100.1728,104.0416 L100.2032,103.976",
  id: "Fill-59",
  fill: "#CFA486"
}), /*#__PURE__*/React.createElement("path", {
  d: "M119.392,112.1136 L103.8368,102.6768 L101.064,106.7328 L118.9648,125.6288 C118.9648,125.6288 123.224,128.16 126.4704,122.7008 C127.256,121.3776 127.3008,119.7392 126.656,118.344 C125.6368,116.1408 124.7712,115.9424 122.8624,114.4448 C120.9584,112.9504 120.0464,112.5104 119.392,112.1136",
  id: "Fill-60",
  fill: "#CFA486"
})), /*#__PURE__*/React.createElement("path", {
  d: "M92.0691167,63.205104 C92.0691167,63.205104 91.2199678,67.9943918 86.5667167,65.416304 C86.5667167,65.416304 89.4355167,64.990704 92.0691167,63.205104 Z",
  id: "Fill-39",
  fill: "#3B3C3A",
  transform: "translate(89.317917, 64.691772) rotate(16.000000) translate(-89.317917, -64.691772) "
})))));

var SvgLadyDesk = function SvgLadyDesk(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "160px",
    height: "160px",
    viewBox: "0 0 160 160",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLadyDesk, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lady-desk.d21f0ea7.svg";
export { ForwardRef as ReactComponent };